import { Color, airportsColorTheme } from '../../../../styles/Color';

interface ITerminalInfo {
	terminal?: string;
	color?: string;
	poiName: string;
}

export const terminalMap: { [key: string]: ITerminalInfo } = {
	IAHAN: {
		terminal: 'A',
		color: airportsColorTheme.hou.secondary,
		poiName: 'Terminal A-North Checkpoint',
	},
	IAHAS: {
		terminal: 'A',
		color: airportsColorTheme.hou.secondary,
		poiName: 'Terminal A-South Checkpoint',
	},
	IAHANPC: {
		terminal: 'A',
		color: airportsColorTheme.hou.secondary,
		poiName: 'Terminal A-North Checkpoint',
	},
	IAHB: {
		terminal: 'B',
		color: Color.Tertiary4,
		poiName: 'Terminal B Checkpoint',
	},
	IAHCN: {
		terminal: 'C',
		color: Color.Secondary,
		poiName: 'Terminal C-North Checkpoint',
	},
	IAHCS: {
		terminal: 'C',
		color: Color.Secondary,
		poiName: 'Terminal C-South Checkpoint',
	},
	IAHD: {
		terminal: 'D',
		color: Color.Error,
		poiName: 'Terminal D Checkpoint',
	},
	IAHE: {
		terminal: 'E',
		color: Color.Tertiary4,
		poiName: 'Terminal E Checkpoint',
	},
	IAHEPC: {
		terminal: 'E',
		color: Color.Tertiary4,
		poiName: 'Terminal E Checkpoint',
	},
	// eslint-disable-next-line @typescript-eslint/naming-convention
	IAH_tsa_security_recheck: {
		terminal: 'E',
		color: Color.PrimaryOrange,
		poiName: 'TSA Security Recheck',
	},
	HOU: {
		poiName: 'Security Checkpoint',
	},
	HOUPC: {
		poiName: 'Security Checkpoint',
	},
	// eslint-disable-next-line @typescript-eslint/naming-convention
	IAH_immigration_and_customs: {
		terminal: 'E',
		color: Color.PrimaryOrange,
		poiName: 'Immigration',
	},
	// eslint-disable-next-line @typescript-eslint/naming-convention
	HOU_immigration_and_customs: {
		poiName: 'Immigration',
	},
};
